export default __webpack_public_path__ + "static/media/outsorcing.42370ad1.svg";